import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LcaListComponent } from './lca-list/lca-list.component';
import { AddLcaNewComponent } from './add-lca-new/add-lca-new.component';
import { ManageLcaComponent } from './manage-lca/manage-lca.component';
import { ViewLcaComponent } from './view-lca/view-lca.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { InternalJobPostingComponent } from './internal-job-posting/internal-job-posting.component';
import { LcaDetailsViewModeComponent } from './lca-details-view-mode/lca-details-view-mode.component';
import { UpdateDecisionComponent } from './update-decision/update-decision.component';
const routes: Routes = [
    {
        path: 'add-new',
        component: ManageLcaComponent,
        canDeactivate: [ DirtyFormGuard ]
    },
    {
        path: 'view-lca-details',
        component: LcaDetailsViewModeComponent,
    },
    {
        path: 'update-lca-decision',
        component: UpdateDecisionComponent,
    },
    {
        path: 'lca',
        component: LcaListComponent,
        pathMatch: 'full'
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'lca'
    },
    {
        path: 'internal-job-posting/:companyName/:companyId',
        component: InternalJobPostingComponent,
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LCARoutingModule { }
